import React, { useState, forwardRef, useCallback, useEffect } from 'react';
import { styled } from '@mui/joy/styles';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import Input from '@mui/joy/Input';



import ImageBmw from '../../assets/bmw.png';
import CancelIcon from '@mui/icons-material/Cancel';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ImagePlaceholder from '../../assets/imagePlaceholder.png';



///////////////////// Modal
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import SvgIcon from '@mui/joy/SvgIcon';
import ModalDialog from '@mui/joy/ModalDialog';




//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';



//////////////////////// API
import { getAllImagesSectionOne, createImagesSectionOne, deleteImagesSectionOne } from '../../Api/Content';


const schema = yup.object({
    images: yup.mixed().required("يرجى رفع صوره"),
    // title_ar: yup.string().required("هذا الحقل مطلوب"),
    // title_en: yup.string().required("هذا الحقل مطلوب"),
})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

// const Alert = forwardRef(function Alert(props, ref) {
//     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
// });



export default function UploadImagesSection() {
    const [listAllBrands, setListAllBrands] = useState([])
    const [open, setOpen] = useState(false);
    const [urlImage, setUrlImage] = useState(ImagePlaceholder)
    const [imageDataTwo, setImageDataTwo] = useState(null)
    const [brandId, setBrandId] = useState(null)

    const [openModalConfirm, setOpenModalConfirm] = useState(false)

    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            images: []
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const imgAd = (event) => {
        let image = event.target;
        if (image.files && image.files[0]) {
            setImageDataTwo(image.files[0]);
            console.log(imageDataTwo)
            var reader = new FileReader();
            reader.onload = (e) => {
                setUrlImage(e.target.result);
            }
            reader.readAsDataURL(image.files[0]);
        }
    };

    const sendBrandImage = async (data) => {
        try {
            setLoading(true)
            if (!data.images) {
                // data.images = [data.images[0]]
                return
            }
            let formData = new FormData();
            formData.append("images", data.images[0]);
            const res = await createImagesSectionOne(formData)
            if (res) {
                setLoading(false)
                setOpen(false)
                getAllBrands()
                setOpenAlert(true)
                setMessageAlert('تم اضافة صوره بنجاح')
                setValue('images', [])
                setImageDataTwo(null)
                setUrlImage(ImagePlaceholder)
            }

        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpen(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    };

    const getAllBrands = useCallback(async () => {
        const res = await getAllImagesSectionOne();
        if (res) {
            setListAllBrands(res)
        }
    }, []);

    const openConfirmDelete = (id) => {
        setBrandId(id)
        setOpenModalConfirm(true)
    };

    const deleteBrand = async () => {
        setLoading(true)
        const res = await deleteImagesSectionOne(brandId)
        if (res) {
            setLoading(false);
            setMessageAlert("تم حذف صوره بنجاح")
            setOpenAlert(true)
            setBrandId(null)
            setOpenModalConfirm(false)
            getAllBrands()
        }
    }

    useEffect(() => {
        getAllBrands();
    }, [getAllBrands])


    return (
        <>
            {/* Section Modal Create */}
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                onClose={() => setOpen(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        maxWidth: 500,
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                    }}
                >
                    <ModalClose variant="plain" sx={{ m: 1 }} />
                    <form onSubmit={handleSubmit(sendBrandImage)}>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                            <img src={urlImage} className='viewImageBrand' alt='image ad' />
                            <Button
                                component="label"
                                role={undefined}
                                tabIndex={-1}
                                variant="outlined"
                                color="neutral"
                                sx={{ marginTop: '20px', width: '200px', margin: '20px auto' }}
                                startDecorator={
                                    <SvgIcon>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                                            />
                                        </svg>
                                    </SvgIcon>
                                }
                            >
                                رفع صوره
                                <VisuallyHiddenInput type="file" {...register('images')} onChange={(e) => imgAd(e)} />
                            </Button>
                            {errors.images &&
                                <Typography
                                    color="danger"
                                    level="body-xs"
                                    variant="plain"
                                >{errors.images?.message}</Typography>
                            }
                            <Typography level="h4" sx={{textAlign:'center', margin:'20px 0'}}>يجب رفع صورة بمقاس  100 * 270</Typography>
                        

                            <Button sx={{ width: '250px', margin: 'auto' }} type='submit' loading={loading}>انشاء صوره</Button>
                        </Box>
                    </form>
                </Sheet>
            </Modal>


            {/* Modal Delete PopUp */}
            <Modal open={openModalConfirm} onClose={() => setOpenModalConfirm(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        هل انت متاكد من حذف صوره ؟
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف صوره بشكل دائم وإزالة بياناتك من خوادمنا.
                    </Typography>
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button variant="solid" color="primary" onClick={() => deleteBrand()}>
                            تأكيد
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setOpenModalConfirm(false)}
                        >
                            الغاء
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>





            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>
            <FormControl>
                <FormLabel>صور القسم</FormLabel>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent='flex-start'
                    gap='10px'
                    rowGap='10px'
                    sx={{
                        border: '1px solid #E6E6E6',
                        borderRadius: '15px',
                        padding: '20px',
                        flexWrap: 'wrap'
                    }}
                >
                    {listAllBrands.map((brand) => {
                        return (
                            <Box sx={{ width: '50px', height: '50px', borderRadius: 'lg', p: 1, border: '1px solid #CCD0D6', position: 'relative' }}>
                                <CancelIcon color='error' sx={{ position: 'absolute', top: '-8px', right: '-8px', cursor: 'pointer' }} onClick={() => openConfirmDelete(brand.id)} />
                                <img
                                    src={brand.images}
                                    srcSet={brand.images}
                                    alt="A beautiful landscape."
                                    width={'100%'}
                                />
                            </Box>
                        )
                    })}

                    <Box
                        onClick={() => setOpen(true)}
                        sx={{
                            width: '50px',
                            height: '50px',
                            borderRadius: 'lg',
                            p: 1,
                            border: '1px solid #1976d2',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                        }}
                    >
                        <AddBoxIcon color='primary' />
                    </Box>
                </Stack>
            </FormControl>
        </>
    );
}